import { useTranslation } from "react-i18next";
import { useEstop } from "providers/ARC/EstopProvider";

const EstopToggleButton = () => {
    const { t } = useTranslation("control");
    const { estopEngaged, estopSource, canReleaseFromUi, toggleBusy, toggleEstop } = useEstop();

    const engaged = estopEngaged === true;

    let title = t("estop.engage");
    if (engaged) {
        if (estopSource === "hardware") {
            title = t("estop.latchedHardware");
        } else if (estopSource === "local") {
            title = t("estop.activeLocal");
        } else {
            title = canReleaseFromUi ? t("estop.activeRelease") : t("estop.active");
        }
    }

    const className = engaged
        ? "bg-red-500 text-white ring-2 ring-red-300/90"
        : "bg-red-900 text-white/90";

    return (
        <button
            type="button"
            className={`h-9 w-[5.75rem] shrink-0 rounded-r5 px-2 text-h3 font-semibold uppercase tracking-wide disabled:cursor-not-allowed disabled:opacity-70 ${className}`}
            title={title}
            aria-pressed={engaged}
            aria-label={title}
            aria-busy={toggleBusy === true}
            disabled={toggleBusy === true}
            onClick={() => {
                void toggleEstop();
            }}
        >
            {t("estop.label")}
        </button>
    );
};

export default EstopToggleButton;
